module.exports = __webpack_public_path__ + "img/swipe.832edc5c.png";